import { render } from "./CampaignSearch.vue?vue&type=template&id=8a97434c&scoped=true"
import script from "./CampaignSearch.vue?vue&type=script&lang=js"
export * from "./CampaignSearch.vue?vue&type=script&lang=js"

import "./CampaignSearch.vue?vue&type=style&index=0&id=8a97434c&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a97434c"]])

export default __exports__